import styled from 'styled-components'

import { RoleTone, theme } from '../../constants'

const celebrationGradient = `linear-gradient(90deg, ${theme.roleColors.student.main} 0%, ${theme.colors.brandCoralVivid} 100%)`

export const ProgressTrack = styled.div<{ $size: 'small' | 'medium' }>`
  position: relative;
  width: 100%;
  height: ${({ $size }) => ($size === 'medium' ? '8px' : '6px')};
  background: ${theme.colors.backgroundGrey};
  border-radius: ${theme.radii.pill};
`

export const ProgressFill = styled.div<{
  $progress: number
  $tone: RoleTone
  $hasMarker: boolean
  $variant: 'solid' | 'celebration'
}>`
  position: relative;
  width: ${({ $progress, $hasMarker }) =>
    `${$hasMarker ? Math.max(4, $progress) : $progress}%`};
  height: 100%;
  background: ${({ $tone, $variant }) =>
    $variant === 'celebration'
      ? celebrationGradient
      : theme.roleColors[$tone].main};
  background-size: ${({ $progress, $variant }) =>
    $variant === 'celebration'
      ? `${10000 / Math.max($progress, 1)}% 100%`
      : '100% 100%'};
  background-position: left center;
  background-repeat: no-repeat;
  border-radius: inherit;
  transition: width ${theme.motion.slow} ${theme.motion.easing};

  > span {
    position: absolute;
    top: 50%;
    right: 0;
    width: 64px;
    height: 64px;
    display: grid;
    place-items: center;
    transform: translate(50%, -50%);
  }

  > span img {
    width: 64px;
    height: 64px;
    display: block;
    object-fit: contain;
  }

  > span svg {
    width: 40px;
    height: 40px;
    display: block;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`
